// Is this content already on a card? Tables, lists and fact lists sit on a card,
// never straight on the page grid (design system, Card: "What goes on a card").
// Parts that are a card (Panel, Fold, the numbered and section cards, a table's
// own card) say so here, so a Table inside one does not draw a second card.
import { createContext, useContext, type ReactNode } from "react";

const OnCardContext = createContext(false);

export function OnCard({ children }: { children: ReactNode }) {
  return <OnCardContext.Provider value={true}>{children}</OnCardContext.Provider>;
}

export const useOnCard = () => useContext(OnCardContext);

/** Puts its content on the system's card, unless it already sits on one. */
export function CardIfNeeded({ children }: { children: ReactNode }) {
  return useOnCard() ? (
    <>{children}</>
  ) : (
    <div className="card">
      <OnCard>{children}</OnCard>
    </div>
  );
}
